import {
  useMutation,
  useQuery,
  useQueryClient,
  keepPreviousData,
} from "@tanstack/react-query";
import {
  getEmailNotifications,
  markEmailNotificationOpened,
  NOTIFICATION_DEFAULT_PAGE_SIZE,
} from "@/services/notifications";
import type { EmailNotificationQueryParams } from "@/types/api/notifications";

export const useEmailNotifications = (
  params: EmailNotificationQueryParams = {},
  options?: { enabled?: boolean }
) => {
  const { page = 1, per_page = NOTIFICATION_DEFAULT_PAGE_SIZE } = params;

  return useQuery({
    queryKey: ["email-notifications", { page, per_page }],
    queryFn: () => getEmailNotifications({ page, per_page }),
    placeholderData: keepPreviousData,
    enabled: options?.enabled,
  });
};

export const useMarkEmailNotificationOpened = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => markEmailNotificationOpened(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["email-notifications"] });
    },
  });
};
